import { useMemo } from 'react';
import { ContentObjectTypes } from 'content-management-data-lib';
import { LANDING_PAGES_NO_BRANDING, SITE_PAGES_NO_BRANDING } from 'page-lib/constants/scopes';
import usePortalScopes from 'page-lib/hooks/usePortalScopes';
const useHasHubSpotBrandingOnContentType = contentObjectType => {
  const {
    portalScopes,
    hasFetchCompleted
  } = usePortalScopes();
  return useMemo(() => {
    const portalHasWebsitePagesNoBranding = portalScopes.includes(SITE_PAGES_NO_BRANDING);
    const portalHasLandingPagesNoBranding = portalScopes.includes(LANDING_PAGES_NO_BRANDING);
    return hasFetchCompleted && contentObjectType === ContentObjectTypes.LANDING_PAGE && !portalHasLandingPagesNoBranding || contentObjectType === ContentObjectTypes.SITE_PAGE && !portalHasWebsitePagesNoBranding;
  }, [contentObjectType, portalScopes, hasFetchCompleted]);
};
export default useHasHubSpotBrandingOnContentType;